// Dependency-free so gtm.js (generalDataLayer bundle) doesn't pull in utils.js and datastore/i18n.
export function inStockAnywhere (stock) {
	for (const store in stock) {
		if ((! isNaN(store) || store === 'download' || store === 'web') && stock[store] > 0) {
			return true;
		}
	}
	return false;
};
